'use strict'
export { news_left, nuews_right, houseModule, efficient, typeList, houseList }
// 新闻模块
const news_left = [
  {
    title: '招租难',
    des: ['推广渠道有限；', '无法沉淀数据优质渠道；', '招商进度无法全面把控和转化。'],
    img: require('../assets/imgs/d1.png'),
    flag: 0,
  },
  {
    title: '楼宇运营成本高',
    des: ['工作表格种类繁杂；', '无法实时提供资产运营数据；', '多平台交叉使用，数据不互通。'],
    img: require('../assets/imgs/d2.png'),
    flag: 1,
  },
  {
    title: '业务管理效率低',
    des: [
      '传统软件操作繁琐，体验不佳；',
      '资源分散，管理分散，协作程度低；',
      '人员变动导致大量工作中断。',
    ],
    img: require('../assets/imgs/d3.png'),
    flag: 2,
  },
]
const nuews_right = [
  {
    title: '招租难',
    des: ['推广渠道有限；', '无法沉淀数据优质渠道；', '招商进度无法全面把控和转化。'],
    img: require('../assets/imgs/d4.png'),
    flag: 3,
  },
  {
    title: '楼宇运营成本高',
    des: ['工作表格种类繁杂；', '无法实时提供资产运营数据；', ' 多平台交叉使用，数据不互通。'],
    img: require('../assets/imgs/d5.png'),
    flag: 4,
  },
  {
    title: '业务管理效率低',
    des: [
      '统软件操作繁琐，体验不佳',
      '资源分散，管理分散，协作程度低；',
      '人员变动导致大量工作中断。',
    ],
    img: require('../assets/imgs/d6.png'),
    flag: 5,
  },
]
// 产品模型
const houseModule = [
  {
    title: '楼宇开拓',
    img: require('../assets/imgs/module10.png'),
  },
  {
    title: '工程改造',
    img: require('../assets/imgs/module9.png'),
  },
  {
    title: '楼宇招商',
    img: require('../assets/imgs/module8.png'),
  },
  {
    title: '运营管理',
    img: require('../assets/imgs/module7.png'),
  },
  {
    title: '物业管理',
    img: require('../assets/imgs/module6.png'),
  },
  {
    title: '进销存',
    img: require('../assets/imgs/module5.png'),
  },
  {
    title: '财务管理',
    img: require('../assets/imgs/module4.png'),
  },
  {
    title: '智能设备',
    img: require('../assets/imgs/module3.png'),
  },
  {
    title: '行政管理',
    img: require('../assets/imgs/module2.png'),
  },
  {
    title: '人事管理',
    img: require('../assets/imgs/module1.png'),
  },
]
// 高效模块
const efficient = [
  {
    darck: require('../assets/imgs/e1.png'),
    white: require('../assets/imgs/e1_.png'),
    title: '管理者',
    list: [
      {
        des: '房源管理高效：房源分布再广，也可高效管理房源，实时查看房源情况。',
      },
      {
        des: '智能预警机制：合约到期前，提前预警提醒预约，告别房源空置成本流失。',
      },
      {
        des: '业务闭环溯源：全流程业务闭环，数据互通，让每一个房源、客户，都可溯源',
      },
      {
        des: '科学数据决策：多维度实时统计分析，避免人工失误，做到依靠数据做决策，再通过数据反馈结果',
      },
    ],
  },
  {
    darck: require('../assets/imgs/e2.png'),
    white: require('../assets/imgs/e2_.png'),
    title: '招商',
    list: [
      {
        des: '海量渠道推广：平台提供',
      },
      {
        des: '海量经纪人资源，可一键推送房源。',
      },
      {
        des: '房源实时管理：实时查看空置、已租的房源情况。',
      },
      {
        des: '客户带看跟进：客户带看实时跟进，闹钟提醒下次跟进，高效促进成交。',
      },
      {
        des: '在线签约审批：在线合同审批签订，避免人工起草失误。',
      },
    ],
  },
  {
    darck: require('../assets/imgs/e3.png'),
    white: require('../assets/imgs/e3_.png'),
    title: '运营',
    list: [
      {
        des: '入退管理便捷：一键办理租客入住、转租、退租业务……',
      },
      {
        des: '智能管理水电：在线一键抄表，快捷充值通断电。',
      },
      {
        des: '工单实时跟进：线上报修派单，实时跟踪进展。',
      },
      {
        des: '在线协议模板：数据直接生成文档模板，打印即可签订。',
      },
      {
        des: '费用收缴提醒：付款周期自动提醒，可根据需求进行其他方式提醒（短信、公众号推送）。',
      },
    ],
  },
  {
    darck: require('../assets/imgs/e4.png'),
    white: require('../assets/imgs/e4_.png'),
    title: '工程',
    list: [
      {
        des: '成本数据管控：联动管理项目预算决算费用，使成本计划的执行始终处于监控之下，防止成本失控。',
      },
      {
        des: '分包结算明晰：劳务费用发放有据可依，降低劳务队伍工资发放风险。',
      },
      {
        des: '工程质量把控：进程汇报让一线施工人员履行职责、对安全隐患排查整治及时、整改有效进行追踪、闭合管理。',
      },
    ],
  },
  {
    darck: require('../assets/imgs/e5.png'),
    white: require('../assets/imgs/e5_.png'),
    title: '财务',
    list: [
      {
        des: '收支审批校对：所有收支审批流水清晰明了，提高人工线上线下核账效率。',
      },
      {
        des: '发票收据管理：运营实时登记票据，财务一键核对，避免工作重复繁琐。',
      },
      {
        des: '财务四大报表：收支、利润、现金流、资产负债等报表实时生成。',
      },
    ],
  },
]
// 用用楼宇数据
const typeList = [
  {
    title: '基础版',
    price: '1690',
    type: 'basics',
  },
  {
    title: '高级版',
    price: '3380',
    type: 'senior',
  },
  {
    title: '专业版',
    price: '5070',
    type: 'major',
  },
]
const houseList = [
  {
    title: '资源服务包',
    basicsImg: require('../assets/imgs/some.png'),
    seniorImg: require('../assets/imgs/some.png'),
    majorImg: require('../assets/imgs/all.png'),
    children: [
      {
        title: '房产经纪资源',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '导出资源包',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/null.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '商办消控大盘实时统计',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/null.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '短信群发功能',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
    ],
  },
  // {
  //   title: '第三方平台',
  //   basicsImg: require('../assets/imgs/all.png'),
  //   seniorImg: require('../assets/imgs/all.png'),
  //   majorImg: require('../assets/imgs/all.png'),
  //   children: [
  //     {
  //       title: '钉钉平台对接',
  //       basicsImg: require('../assets/imgs/all.png'),
  //       seniorImg: require('../assets/imgs/all.png'),
  //       majorImg: require('../assets/imgs/all.png'),
  //       isText: false,
  //     },
  //     {
  //       title: '企业微信平台对接',
  //       basicsImg: require('../assets/imgs/all.png'),
  //       seniorImg: require('../assets/imgs/all.png'),
  //       majorImg: require('../assets/imgs/all.png'),
  //       isText: false,
  //     },
  //     {
  //       title: '微信小程序平台对接',
  //       basicsImg: require('../assets/imgs/all.png'),
  //       seniorImg: require('../assets/imgs/all.png'),
  //       majorImg: require('../assets/imgs/all.png'),
  //       isText: false,
  //     },
  //     {
  //       title: '飞书平台对接',
  //       basicsImg: require('../assets/imgs/all.png'),
  //       seniorImg: require('../assets/imgs/all.png'),
  //       majorImg: require('../assets/imgs/all.png'),
  //       isText: false,
  //     },
  //   ],
  // },
  {
    title: '业务模块',
    basicsImg: require('../assets/imgs/some.png'),
    seniorImg: require('../assets/imgs/all.png'),
    majorImg: require('../assets/imgs/all.png'),
    children: [
      {
        title: '城市区域',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '项目管理',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '工程管理',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '资产管理',
        color: '#8BBFFC',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '招商管理',
        color: '#8BBFFC',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '租客管理',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '工单管理',
        color: '#8BBFFC',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '运营管理',
        color: '#8BBFFC',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '公司行政',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '公司人事',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '公司资产',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '财务管理',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
    ],
  },
  {
    title: '增值包',
    basicsImg: require('../assets/imgs/all.png'),
    seniorImg: require('../assets/imgs/all.png'),
    majorImg: require('../assets/imgs/all.png'),
    children: [
      {
        title: '超级管理员',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '企业账号数',
        basicsText: '20人',
        seniorText: '50人',
        majorText: '80人',
        isText: true,
      },
      {
        title: '短信包',
        basicsText: '1000条',
        seniorText: '3000条',
        majorText: '5000条',
        isText: true,
      },
      {
        title: '文件储存包',
        basicsText: '50G',
        seniorText: '100G',
        majorText: '200G',
        isText: true,
      },
      {
        title: '图片识别包',
        basicsText: '10次',
        seniorText: '30次',
        majorText: '50次',
        isText: true,
      },
      {
        title: '打印模板设计',
        basicsText: '10个',
        seniorText: '50个',
        majorText: '80个',
        isText: true,
      },
      {
        title: '智能电表',
        basicsText: '按表购买',
        seniorText: '按表购买',
        majorText: '按表购买',
        isText: true,
      },
    ],
  },
  {
    title: '系统功能',
    basicsImg: require('../assets/imgs/some.png'),
    seniorImg: require('../assets/imgs/all.png'),
    majorImg: require('../assets/imgs/all.png'),
    children: [
      {
        title: '系统数据',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '电子合同',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '智能报表',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '流程审批管理',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '数据展示管理',
        basicsImg: require('../assets/imgs/all.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '数据卡片',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '消息推送',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
      {
        title: '智能报表设计',
        basicsImg: require('../assets/imgs/null.png'),
        seniorImg: require('../assets/imgs/all.png'),
        majorImg: require('../assets/imgs/all.png'),
        isText: false,
      },
    ],
  },
]
